module.exports = {
	"dk": {
		"nfl": "NFL",
		"e-sport": "E-Sport",
		"Dakar Rally": "Formel 2",
		"moto-3": "Formel 3",
		"british-superbike": "IMSA",
		"rio-2016": "Tokyo 2021"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/sportDisplayName.json
// module id = 1210
// module chunks = 1 2